import $ from "jquery";
import "../bootstrap.js";
window.$ = $;
window.jQuery = $;

document.addEventListener("DOMContentLoaded", async () => {
    const anchorEl = document.querySelectorAll(".handle-anchor");
    if (anchorEl) {
        const { initAnchorLink } = await import("../components/anchorlink.js");
        initAnchorLink();
    }

    const panoEls = document.getElementById("pano");

    if (panoEls) {
        const loadKrpanoScript = () => {
            return new Promise((resolve, reject) => {
                if (typeof window.embedpano !== "undefined") {
                    resolve();
                    return;
                }

                const script = document.createElement("script");
                script.src = "/assets/krpano/tour.js";
                script.onload = () => {
                    resolve();
                };
                script.onerror = () => {
                    reject();
                };
                document.head.appendChild(script);
            });
        };

        loadKrpanoScript()
            .then(() => {
                window.embedpano({
                    swf: "/assets/krpano/tour.swf",
                    xml: "/assets/krpano/tour.xml",
                    target: "pano",
                    html5: "prefer",
                    mobilescale: 1.0,
                    passQueryParameters: true,
                });
            })
            .catch(() => {});
    }
});
